import {useEffect, useState} from "react";
import {Button, MenuItem, Select, TextField} from "@mui/material";
import * as React from "react";
import FunctionsData from "../../../Functions/FunctionsData";

export default function VouchersTableShowFilters({ 
    showModal,
    setSearchTerm, 
    from, 
    setFrom, 
    to, 
    setTo, 
    campaigns, 
    setSearchCampaign, 
    searchCampaign,
    businessName
}) {
    const [data, setData] = useState([]);
    const [t, setT] = useState('');
    const [issuedCount, setIssuedCount] = useState(0);
    const [redeemedCount, setRedeemedCount] = useState(0);
    const [loading, setLoading] = useState(false);

    // Fetch data when businessName or searchCampaign changes, and modal is not shown
    useEffect(() => {
        if (!businessName || showModal) return;

        setLoading(true);

        let apiUrl = `/api/voucher/counts?business_name=${encodeURIComponent(businessName)}`;
        if (searchCampaign && searchCampaign.toLowerCase() !== 'all') {
            apiUrl += `&campaign_name=${encodeURIComponent(searchCampaign)}`;
        }

        FunctionsData.fetchDataGet(
            FunctionsData.getApiUrl(apiUrl),
            setData,
            true,
            setLoading
        );
    }, [businessName, searchCampaign, showModal]);

    // When data changes, update issuedCount and redeemedCount
    useEffect(() => {
        if (data && data.length !== undefined && data.length > 0) {
            // If data is an array, might need to adjust logic.
            // Check if data is { issued: ..., redeemed: ... } or { data: { issued: ..., redeemed: ... } }
            const result = data?.data || data;
            setIssuedCount(result.issued || 0);
            setRedeemedCount(result.redeemed || 0);
            setLoading(false);
        } else if (data && !Array.isArray(data)) {
            // If data is an object directly
            const result = data?.data || data;
            setIssuedCount(result.issued || 0);
            setRedeemedCount(result.redeemed || 0);
            setLoading(false);
        }
    }, [data]);

    if (showModal === true) return null;

    return (
        <div style={{flex:'1 0 0%', display:'flex', margin:'0', padding:5, background:'#e9f5ff' }}>
            <TextField sx={{minWidth: '350px', margin: 1}}
                       placeholder={"Start typing to search for a voucher number ..."}
                       variant="outlined"
                       value={t}
                       onChange={(e) => {
                           setT(e.target.value);
                           setSearchTerm(e.target.value);
                       }}
            />
            <TextField sx={{margin:1}} 
                       type={"date"} 
                       label={"From"} 
                       focused 
                       value={from} 
                       onChange={(e) => setFrom(e.target.value)} 
            />
            <TextField sx={{margin:1}} 
                       type={"date"} 
                       label={"To"} 
                       focused 
                       value={to} 
                       onChange={(e) => setTo(e.target.value)}  
            />

            <div>
                <Select
                    sx={{margin:1}}
                    labelId="select-campaigns-label"
                    id="select-campaigns"
                    value={searchCampaign}
                    label="Campaign"
                    onChange={(e) => setSearchCampaign(e.target.value)}
                >
                    <MenuItem value={"all"}>All campaigns</MenuItem>
                    {campaigns.map((c,idx) => (
                        <MenuItem key={idx} value={c}>{c}</MenuItem>
                    ))}
                </Select>
            </div>

            {/* Display live count stats here */}
            <div style={{display:'flex', alignItems:'center', marginLeft: '20px'}}>
                <span style={{marginRight:'15px'}}>Issued Vouchers: {issuedCount}</span>
                <span style={{marginRight:'15px'}}>Redeemed Vouchers: {redeemedCount}</span>
            </div>

            <Button onClick={() => {
                setFrom(false);
                setTo(false);
                setSearchCampaign('all');
            }}>Clear</Button>
        </div>
    );
}
